import React,{useCallback,useContext,useEffect, useState,useRef} from 'react';
import { getRequest, postRequest, putRequest,deleteRequest } from '../../../api/ApiController';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon} from "../../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import { InfinitySpin } from  'react-loader-spinner';
import { DateTime } from "luxon";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../../utils/tabulatorRuntimeI18n';

const PRIORITY_LOAD_MANUALLY_LIST_COLUMN_I18N_KEYS = Object.freeze({
  name: 'PriorityLoadManuallyList.Column.Name',
  abbreviation: 'PriorityLoadManuallyList.Column.Abbreviation',
  custom_departments: 'PriorityLoadManuallyList.Column.Departments',
});

export default function PriorityLoadManuallyList(){

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const { t, locale } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,setFastView,visible,setUserMaskFilter,hasAll, openChosenNotificationPreferences} = useContext(UtilContext);

    const [insertIcon,setInsertIcon] = useState(!user.permissions?.includes('add priorities-setup'));
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [scrollValue,setScrollValue] = useState(1);

    const [columnsVisible, setColumnsVisible] = useState({name: true,abbreviation: true,custom_departments:true,});
    const [maskVisible, setMaskVisible] = useState(false);
const [markUnmark, setMarkUnmarked] = useState(true);

    const [editFormPaintingInterval, setEditFormPaintingInterval] = useState([]);

    const ref = useRef(null);
    const toast = useRef(null);
    const elementRef = useRef(null);
    const overlayRef = useRef(null);
    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);

  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: PRIORITY_LOAD_MANUALLY_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);

    useEffect(() => {
      if (state.priority_departments && ref.current && state.priority_departments_reaload) {
        ref.current.updateData(state.priority_departments);
        //lepsie vymysliet reload
        //dat hook na to
      }
    },[state.priority_departments,ref.current,state.priority_departments_reaload]);
  
  
  function matchAny(data, filterParams) {
    //data - the data for the row being filtered
    //filterParams - params object passed to the filter
    //RegExp - modifier "i" - case insensitve

    var match = false;
    const regex = RegExp(filterParams.value, 'i');

    for (var key in data) {
        if (regex.test(data[key]) === true) {
            match = true;
        }
    }
    return match;
  }

  function searchTable(){
    ref.current.setFilter(matchAny, { value: searchValue});
    if (searchValue === " ") {
      ref.current.clearFilter()
    }
    setVisibleSearch(false);
  }

    const accept = () => {
        let rows_to_delete = [];
        rows_to_delete = ref.current.getSelectedData();
        rows_to_delete.forEach(element => {
          console.log(element);
          deleteRequest(`/api/priority_departments/${element.id}`)
              .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                getRequest("/api/priority_departments").then((response) => {
                  dispatch({type:'load_priority_departments',newPriorityDepartments:response.data});
                  dispatch({type:'priority_departments_reload',value:true});
                  dispatch({type:'priority_departments_reload',value:false});
              });
              }).catch((reason) => {
                  alert(reason);
                  toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
              })
        });
        //toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
    }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('ServiceTask.ConfirmDeleteRecord'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.Yes'),
            rejectLabel: t('Common.No'),
            accept,
            reject
        });
    };

  const rowClick = (e, row) => {
    console.log(e, row);
 };

  const onSelectRow = (data, rows) => {
    setEditFormPaintingInterval(data);
    setEditIcon(true);
    setCopyIcon(true);
    setDeleteIcon(true);
    if(data.length !== 0){
      if(user.permissions?.includes('edit priorities-setup'))setCopyIcon(false);
      if(user.permissions?.includes('edit priorities-setup'))setEditIcon(false);
      if(user.permissions?.includes('delete priorities-setup'))setDeleteIcon(false);
    }
  };

  function DepartmentsFormatter(props) {
    const rowData = props.cell._cell.row.data;
    //G Y
    return rowData.departments.map((item) => item.name).join(' ');
  }

  function departmentHeaderFilter(headerValue, rowValue, rowData, filterParams){
    //headerValue - the value of the header filter element
    //rowValue - the value of the column in this row
    //rowData - the data for the row being filtered
    //filterParams - params object passed to the headerFilterFuncParams property
    let departments = rowData.departments.map(item => item.name);
    for(let i = 0;i<departments.length;i++){
      let filter = headerValue.toLowerCase();
      let value = departments[i].toLowerCase();
      console.log("DEP: "+value+" FILTER: "+filter);
      if(value.includes(filter)){
        return true
      }
    }
    return false;
  }

    function onEditRow(id){
      let selected = ref.current.getSelectedData();
      console.log(id,selected);
      for(let i=0;i<selected.length;i++){
        if(selected[i].id == id){
          editPriorityLoad(selected[i]);
          break;
        }
      }
  };

  function EditRowFormatter(props) {
    const rowData = props.cell._cell.row.data;
    return <div className='flex justify-center items-start w-full h-full'><button type='button' onClick={() => onEditRow(rowData.id)}><EditRowIcon/></button></div>;
  }

  const [draggingItem,setDraggingItem] = useState(null); 
  const [columns,setColumns] = useState([
    { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center",width: 20,headerSort:false,resizable:false,frozen:true},
    { hozAlign:"center",width: 20,headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),frozen:true,resizable:false},
    { title: t('PriorityLoadManuallyList.Column.Name'), field: 'name',headerFilter:"input",minWidth: 200,resizable:false},
    { title: t('PriorityLoadManuallyList.Column.Abbreviation'), field: 'abbreviation',headerFilter:"input" ,minWidth: 200,resizable:false},
    { title: t('PriorityLoadManuallyList.Column.Departments'), field: 'custom_departments',headerFilter:"input",headerFilterFunc:departmentHeaderFilter,minWidth: 200,formatter: reactFormatter(<DepartmentsFormatter/>),resizable:false },
  ]);

  async function scrollToFirst(){
    let res = state.priority_departments[0].id;
    ref.current.scrollToRow(res, "top", true);
    setScrollValue(1);
  }

  async function scrollUp(){
    let visible_rows = Math.floor((elementRef.current.clientHeight-68)/30-1);
    if((scrollValue-visible_rows+1) >= 0){
      let res = state.priority_departments[scrollValue-visible_rows+1].id;
      ref.current.scrollToRow(res, "top", true);
      setScrollValue(scrollValue-visible_rows);
    }
    else if(scrollValue > 0 && scrollValue <= visible_rows){
      let res = state.priority_departments[0].id;
      ref.current.scrollToRow(res, "top", true);
      setScrollValue(1);
    }
  }

  async function scrollDown(){
    let visible_rows = Math.floor((elementRef.current.clientHeight-68)/30-1);
    let rows = ref.current.getRows(true).length;
    if(scrollValue===1){
      let res = state.priority_departments[scrollValue+visible_rows-1].id;
      ref.current.scrollToRow(res, "top", true);
      setScrollValue(scrollValue+visible_rows);
    }
    else if((scrollValue+visible_rows) <= rows){
      let res = state.priority_departments[scrollValue+visible_rows-1].id;
      let rows = ref.current.getRows(true).length;
      setScrollValue(scrollValue+visible_rows);
      if(res > rows-visible_rows){
        res = state.priority_departments[rows-visible_rows].id;
        setScrollValue(rows-visible_rows);
      }
      ref.current.scrollToRow(res, "top", true);
    }
  }

  async function scrollToLast(){
    let visible_rows = Math.floor((elementRef.current.clientHeight-68)/30-1);
    let rows = ref.current.getRows(true).length;
    let res = state.priority_departments[rows-visible_rows].id;
    ref.current.scrollToRow(res, "top", true);
    setScrollValue(rows-visible_rows);
  }
   
  function addNewPriorityLoad(){
      dispatch({type:'create_new_tab',name:t('PriorityLoadManuallyList.Tab.Add'), translationKey: 'PriorityLoadManuallyList.Tab.Add', legacyLabel: t('PriorityLoadManuallyList.Tab.Add'), page:'PriorityLoadAdd',props:{priority_load: null,type:'add',load_type:'automatic'},mask:'prio008'})
    }

    function copyPriorityLoad(){
      dispatch({type:'create_new_tab',name:t('PriorityLoadManuallyList.Tab.Add'), translationKey: 'PriorityLoadManuallyList.Tab.Add', legacyLabel: t('PriorityLoadManuallyList.Tab.Add'), page:'PriorityLoadAdd',props:{priority_load: ref.current.getSelectedData()[0],type:'add',load_type:'automatic'},mask:'prio008'})
    }

  function editPriorityLoad(value=null){
    if(value!=null){
      dispatch({type:'create_new_tab',name:t('PriorityLoadManuallyList.Tab.Edit'), translationKey: 'PriorityLoadManuallyList.Tab.Edit', legacyLabel: t('PriorityLoadManuallyList.Tab.Edit'), page:'PriorityLoadAdd',props:{priority_load: value,type:'edit',load_type:'automatic'},mask:'prio008'})
    }
    else{
      dispatch({type:'create_new_tab',name:t('PriorityLoadManuallyList.Tab.Edit'), translationKey: 'PriorityLoadManuallyList.Tab.Edit', legacyLabel: t('PriorityLoadManuallyList.Tab.Edit'), page:'PriorityLoadAdd',props:{priority_load: ref.current.getSelectedData()[0],type:'edit',load_type:'automatic'},mask:'prio008'})
    }
  }

  function handleDragStart(e, item){ 
    setDraggingItem(item);
    e.dataTransfer.setData('text/plain', ''); 
  }; 

  function handleDragEnd(){ 
    setDraggingItem(null);
  }; 

  function handleDragOver(e){ 
      e.preventDefault(); 
  }; 

  function handleDrop(e, targetItem){ 
      if (!draggingItem) return; 

      const currentIndex = columns.indexOf(draggingItem); 
      const targetIndex = columns.indexOf(targetItem); 

      if (currentIndex !== -1 && targetIndex !== -1) { 
        columns.splice(currentIndex, 1); 
        columns.splice(targetIndex, 0, draggingItem); 
         
      } 
      ref.current.setColumns(columns);
  }; 

function setMask(item,value){
  const columnVisible = {...columnsVisible};
  columnVisible[item] = value;
  for(const val in columnVisible) {
    if(columnVisible[val]==false){
      ref.current.hideColumn(`${val}`);
    }
    else{
      ref.current.showColumn(`${val}`);
    }
  }
  setColumnsVisible(columnVisible);
}

  const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );

  const [expandedKeys, setExpandedKeys] = useState({});

  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
    }
  };

  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
          document.removeEventListener('click', handleClickOutside, true);
      };
  }, []);

    const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
        {
          key: '0_1',
          label: t('Common.ClearFilter'),
          icon: 'pi pi-filter-slash',
          command: () => {setUserMaskFilter("ZoznamInt","set_filters",null,[],null);ref.current.clearHeaderFilter();},
          template: itemRenderer,
      },
      {
          key: '0_2',
          label: t('Common.SetMask'),
          icon: 'pi pi-server',
          command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
          template: itemRenderer,
      },
      {
        key: '0_3',
        label: t('Common.Notifications'),
        icon: 'pi pi-envelope',
        command: () => {openChosenNotificationPreferences('PriorityLoadManuallyList');OverflowMenuProvider.setVisible(null);},
        template: itemRenderer,
    },
      ]
    }
  ];
function changeMarkings(value){
    if(value){
      const columnVisible = {...columnsVisible};
      for(let val in columnVisible) {
        if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
          columnVisible[val]=true;
          ref.current.showColumn(`${val}`);
        }
      };
      setColumnsVisible(columnVisible);
    }
    else{
      const columnVisible = {...columnsVisible};
      for(let val in columnVisible) {
        if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
          columnVisible[val]=false;
          ref.current.hideColumn(`${val}`);
        }
      };
      setColumnsVisible(columnVisible);
    }
  }

    return(
      <>
      <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewPriorityLoad()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editPriorityLoad()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyPriorityLoad()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => ref.current.print(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="search"><button onClick={() => setVisibleSearch(true)}><SearchIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="export"><button onClick={() => ref.current.download("xlsx", "data.xlsx", {sheetName:"MyData"})}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('PriorityLoad.ManualTitle'),"PriorityLoadManuallyList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("PriorityLoadManuallyList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100] " data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
        </IntersectionObserverWrapper>
      </div>
<div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    <div ref={elementRef}>
      <ReactTabulator
      data={state.priority_departments} 
      className='h-[calc(100vh_-_176px)]' //176px
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow
      }}
      options={{renderHorizontal:"virtual",movableColumns: true,
      printAsHtml:true,
      printHeader: () => buildCanonicalPrintHeaderHtml({
        branding: state?.branding,
        productFallbackSrc: defaultProductLogoSrc,
        companySettingsPrint: state?.company_settings_print,
        moduleSettings: state?.module_settings,
        title: t('PriorityLoadManuallyList'),
        printDateLabel: t('Print.DateLabel'),
      }),
      printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
      printRowRange:"active"}}/> 
    </div> 
  </div> 
</div> 
</div>
          <ConfirmDialog />
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
      <Dialog visible={visibleLoading} style={{ width: '25vw',height:'25vh',backgroundColor: 'transparent',boxShadow: 'none'}} className='mypanel flex flex-row'  closable={false} draggable={false} showHeader={false}>
          <InfinitySpin 
          width='208'
          color="#000"
          />
          <p className='text-2xl font-bold text-center w-52 text-black'>{t('Common.LoadingEllipsis')}</p>
      </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                        draggable="true"
                        onDragStart={(e) =>  
                            handleDragStart(e, item)} 
                        onDragEnd={() => handleDragEnd()} 
                        onDragOver={(e) => handleDragOver(e)} 
                        onDrop={(e) => handleDrop(e, item)} 
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })}
                 <button onClick={() => {setUserMaskFilter("ZoznamInt","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('TaskTemplateList.MaskSave')}</button>
        </div>
      </Dialog>
</div> 
 </>
    )

}